module.exports = __webpack_public_path__ + "static/media/sample_holidays.beba1b68.csv";